import React from 'react';
import { applySizeToProps } from '../utils/applySizeToProps';
import { IconProps } from '../types';

export const IconV2LockOutline: React.FC<IconProps> = (props) => (
  <svg {...applySizeToProps(props)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="1em" height="1em"><path d="M16.866 18h2.31l-4.042 7h-2.31zM26 28l-1.4 2H6V13h3V9c0-3.86 3.14-7 7-7s7 3.14 7 7v4h3v13h-2V15H8v13zM11 13h10V9c0-2.757-2.243-5-5-5s-5 2.243-5 5z" /></svg>
);
